<template>
  <div>

    <v-app class="app-container-custom" v-on:mousedown.native="removeTemporaryOnClickMessages">
      <AlertBar :alert-case="alertCase"></AlertBar>
      <Sidebar/>
      <MainView></MainView>
      <RightSidebar></RightSidebar>
      <BettingBotPolling v-if="isTrader"></BettingBotPolling>
      <!--    <v-btn-->
      <!--      color="primary"-->
      <!--      dark-->
      <!--      @click.stop="showDialogMobile"-->
      <!--    >Show modal</v-btn>-->
    </v-app>
  </div>
</template>

<script>
import Vue from 'vue';
import Sidebar from './components/Sidebar.vue';
import RightSidebar from './components/RightSidebar.vue';
import MainView from './components/MainView.vue'
import AlertBar from './components/other/kryptAlert.vue'
import BettingBotPolling from "@/components/BettingBotPolling";

export default Vue.extend({
  name: 'App',

  components: {
    Sidebar,
    RightSidebar,
    MainView,
    AlertBar,
    BettingBotPolling
  },
  computed: {
    isTrader: function () {
      return this.$store.state.user.isTrader
    },
    alertCase: function () {
      if (this.isInLockdown) {
        return 'lockdown'
      } else if (this.botActionMessage !== null) {
        return this.botActionMessage
      } else if (this.appIsOnline === false) {
        return 'appOffline'
      } else if (this.backendConnectionEstablished === false) {
        return 'noWsConnection'
      } else if (!this.feedIsOnline) {
        return 'feedOffline'
      } else {
        return 'online'
      }
    },
    isInLockdown: function () {
      return this.$store.state.isInLockdown;
    },
    feedIsOnline: function () {
      return this.$store.state.feedIsOnline;
    },
    botActionMessage: function () {
      return this.$store.state.alertMessage
    },
    appIsOnline: function () {
      return this.$store.state.appIsOnline;
    },
    backendConnectionEstablished: function () {
      return this.$store.state.backendConnectionEstablished;
    },
    rightBarEnabled: function () {
      return (this.$store.state.deviceMode === 'desktop' || this.$store.state.deviceMode === 'laptop')
    },
    isMobile: function () {
      {
        return this.$store.state.isMobile;
      }
    },
    isChoosingLeaguesMobile: function () {
      return this.$store.state.navigations.isChoosingLeaguesMobile;
    }
  },
  methods: {
    removeTemporaryOnClickMessages: function () {
      this.$store.commit('removeTemporaryOnClickMessages')
    },
    handleHashChanged: function () {
      try {
        if (!window.triggeredHash) {
          let decodedHash = (decodeURIComponent(window.location.hash.slice(1)));
          if (decodedHash !== '' && decodedHash !== '/' && JSON.stringify({
            sport: this.$store.state.navigations.selectedSportData,
            tournament: this.$store.state.navigations.selectedTournament,
            category: this.$store.state.navigations.selectedCategory
          }) !== decodedHash) {
            this.$store.dispatch('updateNavigation', JSON.parse(decodedHash))
          } else if (decodedHash === '' || decodedHash === '/') {
            this.$store.dispatch('updateNavigation', {
              sport: 'none',
              tournament: 'none',
              category: 'none',
              eventId: 'none'
            })

          }
        } else {
          window.triggeredHash = false;
          console.log('set hash FALSE')

        }
      } catch (e) {
        console.log('update-navigation')
        // this.$store.dispatch('updateNavigation',{
        //   sport : 'none',
        //   tournament : 'none',
        //   category : 'none',
        //   event : 'none'
        // })

        console.log(e);
      }
    },
    showDialogMobile: function () {
      let flag = this.isChoosingLeaguesMobile;
      this.$store.commit('setIsChoosingLeaguesMobile', !flag);
    },
    handleResize: function () {
      this.calculateBreakPoint()
    },
    calculateBreakPoint: function () {
      if (window.innerWidth >= 1500) {
        this.$store.commit('setDeviceMode', 'desktop');
      } else if (1280 <= window.innerWidth && window.innerWidth < 1500) {
        this.$store.commit('setDeviceMode', 'laptop');
      } else if (884 <= window.innerWidth && window.innerWidth < 1280) {
        this.$store.commit('setDeviceMode', 'tablet');
      } else if (631 <= window.innerWidth && window.innerWidth < 884) {
        this.$store.commit('setDeviceMode', 'mobile-landscape');
      } else {
        this.$store.commit('setDeviceMode', 'mobile-portrait');
      }
      //Calculate if should detach the my bets section
      if (1280 <= window.innerWidth) {
        this.$store.commit('setDetachedBetsMode', window.innerHeight < 768);
      }

    }
  },
  mounted: function () {
    // this.$store.dispatch('getBotSupportedMarkets');
    this.calculateBreakPoint();
    window.addEventListener('resize', this.handleResize);
    window.onhashchange = this.handleHashChanged;

    //Connectivity handlers
    window.addEventListener('load', function (e) {
      if (navigator.onLine) {
        this.$store.commit('setAppIsOnline', true)
      } else {
        this.disconnectionTimeout = setTimeout(function () {
          this.$store.commit('setAppIsOnline', false)
        }.bind(this), 3000);
      }
    }.bind(this), false);
    window.addEventListener('online', function (e) {
      clearTimeout(this.disconnectionTimeout);
      this.reconnectionTimeout = setTimeout(function () {
        this.$store.commit('setAppIsOnline', true)
      }.bind(this), 3000)
    }.bind(this), false);

    window.addEventListener('offline', function (e) {
      clearTimeout(this.reconnectionTimeout);
      this.disconnectionTimeout = setTimeout(function () {
        this.$store.commit('setAppIsOnline', false)
      }.bind(this), 3000)
    }.bind(this), false);
  },

  data: () => ({
    disconnectionTimeout: {},
    reconnectionTimeout: {}

    //
  }),
});
</script>
<style scoped>
.app-container-custom {
  background: #F4F5F7 !important;
}

</style>
